export default __webpack_public_path__ + "static/media/magnochem.b11a27e3.png";